import Input from './Input';

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input/index.js